// extracted by mini-css-extract-plugin
export default {"formHeading":"YI-z","form":"ZI-z","submitBtn":"_I-z","disabled":"aJ-z","input":"bJ-z","error":"cJ-z","submitMsg":"dJ-z","signIn":"eJ-z"};